import { render, staticRenderFns } from "./TekNatija.vue?vue&type=template&id=90b2f1ea"
import script from "./TekNatija.vue?vue&type=script&lang=js"
export * from "./TekNatija.vue?vue&type=script&lang=js"
import style0 from "./TekNatija.vue?vue&type=style&index=0&id=90b2f1ea&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports